/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
import * as sharedStyles from './on-market.style';
var colour = variables.colour;
export var propertyHistory = /*#__PURE__*/css("border-top:1px solid ", colour.neutral200, ";margin-top:28px;padding-top:28px;", sharedStyles.mobileInterComponentGap);